var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuMore = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 39.54 39.44",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.99,16.47c1.8,0,3.25,1.46,3.25,3.25s-1.46,3.25-3.25,3.25-3.25-1.46-3.25-3.25,1.46-3.25,3.25-3.25Z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.77,16.47c1.8,0,3.25,1.46,3.25,3.25s-1.46,3.25-3.25,3.25-3.25-1.46-3.25-3.25,1.46-3.25,3.25-3.25Z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55,16.47c1.8,0,3.25,1.46,3.25,3.25s-1.46,3.25-3.25,3.25-3.25-1.46-3.25-3.25,1.46-3.25,3.25-3.25Z",
    style: {
      fillRule: "evenodd"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.77,39.22C9.02,39.22,.27,30.47,.27,19.72S9.02,.22,19.77,.22s19.5,8.75,19.5,19.5-8.75,19.5-19.5,19.5ZM19.77,1.22C9.57,1.22,1.27,9.52,1.27,19.72s8.3,18.5,18.5,18.5,18.5-8.3,18.5-18.5S29.97,1.22,19.77,1.22Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuMore, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Menu_More.04227640.svg";
export { ForwardRef as ReactComponent };